



















import Typed from 'typed.js'
import { Component, Vue, Watch } from 'vue-property-decorator'

@Component
export default class CircledTitle extends Vue {
  /**
   * Current size.
   */
  public size: number = 0

  /**
   * Typed instance.
   */
  public typed: Typed

  /**
   * Get style
   */
  get style() {
    return this.size
      ? { height: this.size + 'px', width: this.size + 'px' }
      : null
  }

  /**
   * Set the size
   */
  public setSize() {
    const { width } = this.$el.getBoundingClientRect()
    if (width) {
      this.size = width
    }
  }

  /**
   * Before destroy.
   */
  public beforeDestroy() {
    window.removeEventListener('resize', this.setSize.bind(this))
    this.typed.destroy()
  }

  /**
   * On mounted hook.
   */
  public mounted() {
    window.addEventListener('resize', this.setSize.bind(this))
    this.setSize()

    this.typed = new Typed('#typed', {
      stringsElement: '#strings',
      typeSpeed: 60,
      backSpeed: 40,
      backDelay: 1000
    })
  }
}
